import type { JSXElement } from 'solid-js'

export function Divider(props: { children: JSXElement }) {
  return (
    <div class="flex h-[21px] items-center justify-center gap-[10px] px-[14px]">
      <div class="h-[2px] w-full grow bg-[#037067]" />
      <div class="shrink-0">
        <span class="text-[14px] text-[#00CEBD]">{props.children}</span>
      </div>
      <div class="h-[2px] w-full grow bg-[#037067]" />
    </div>
  )
}
